const isSynopsys = (organizationName?: string) => (
  organizationName?.toLowerCase() === "synopsys" || organizationName?.toLowerCase() === "synopsys private workspace"
);

export default isSynopsys;
